import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { LocaleService } from '@next/core-lib/i18n';
import { Observable } from 'rxjs';

import {
  FmsDiagnoseFarm,
  FmsDiagnoseCropFieldsResponse,
} from '../../../shared/models/fms-diagnose.model';

export type FmsDiagnoseCropFieldsState =
  | { kind: 'idle' }
  | { kind: 'loading' }
  | { kind: 'syncing' }
  | { kind: 'loaded'; data: FmsDiagnoseCropFieldsResponse }
  | { kind: 'error' }
  | { kind: 'unavailable' };

@Component({
  selector: 'app-fms-diagnose-crop-fields-tab',
  templateUrl: './fms-diagnose-crop-fields-tab.component.html',
  styleUrls: ['./fms-diagnose-crop-fields-tab.component.scss'],
  standalone: false,
})
export class FmsDiagnoseCropFieldsTabComponent {
  @Input({ required: true }) cropFieldsState$!: Observable<FmsDiagnoseCropFieldsState>;

  @Output() readonly retryRequested = new EventEmitter<void>();

  private readonly locale = inject(LocaleService);

  fieldName(field: FmsDiagnoseFarm): string {
    return field.name?.trim() || this.unavailable();
  }

  fieldArea(field: FmsDiagnoseFarm): number | null {
    return field.areaInHectares;
  }

  unavailable(): string {
    return this.locale.translate('fmsDiagnose.shared.unavailable');
  }

  hasData(response: FmsDiagnoseCropFieldsResponse): boolean {
    return (
      response.internalOnlyFields.length > 0 ||
      response.linkedFields.length > 0 ||
      response.providerOnlyFields.length > 0
    );
  }

  requestRetry(): void {
    this.retryRequested.emit();
  }
}
